import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IRpaConnection } from 'app/rpa-bots/core/IRpaBots';

@Component({
    selector: 'bots-list',
    templateUrl: 'bots-list.component.html',
    styleUrls: ['bots-list.component.scss']
})
export class BotsListComponent{

    @Output() selectedBotChanged = new EventEmitter<IRpaConnection>();
    @Input() botsList: IRpaConnection[];
    @Input() isLoading = false;

    public currentBot: IRpaConnection;
    public searchValue: string;

    onSelectedBot(bot: IRpaConnection) {
        this.selectedBotChanged.emit(bot);
    }
}
